<template>
    <v-row justify-center v-if="loaded">
        <v-col cols="12" sm="8" offset-sm="2">
            <div class="px-6">
                <Goals  
                    :goals="goals"
                    lapse="15"
                    @edit="showPlease('showEditGoals')"
                    @track="watchResources"
                    v-if="showGoals" />
                <EditGoals  
                    :goals="goals"
                    lapse="15"
                    @cancel="showPlease('showGoals')"
                    @saved="reinitFromGoals"
                    v-if="showEditGoals" />
                <Resources  
                    :goals="goals"
                    lapse="15"
                    :goal="goalToTrack"
                    @cancel="showPlease('showGoals')"
                    @editYes="showPlease('showResYesEdit')"
                    @editNo="showPlease('showResNoEdit')"
                    @track="watchActions"
                    v-if="showResources" />
                <EditResourcesYes
                    :goals="goals"
                    lapse="15"
                    :goal="goalToTrack"
                    @cancel="showPlease('showResources')"
                    @saved="reinitFromResources"
                    v-if="showResYesEdit" />
                <EditResourcesNo
                    :goals="goals"
                    lapse="15"
                    :goal="goalToTrack"
                    @cancel="showPlease('showResources')"
                    @saved="reinitFromResources"
                    v-if="showResNoEdit" />
                <Actions  
                    :goals="goals"
                    lapse="15"
                    :goal="goalToTrack"
                    :resource="resourceToTrack"
                    @cancel="showPlease('showResources')"
                    v-if="showActions" />
            </div>
        </v-col>
    </v-row>
</template>

<script>
import GoalsArq from '@/services/goalsArq'
import Sign from '@/firebase/sign'
import Personal from '@/firebase/personal'
import Goals from '@/components/mapOfLife/Goals'
import EditGoals from '@/components/mapOfLife/EditGoals'
import Resources from '@/components/mapOfLife/Resources'
import EditResourcesYes from '@/components/mapOfLife/EditResourcesYes'
import EditResourcesNo from '@/components/mapOfLife/EditResourcesNo'
import Actions from '@/components/mapOfLife/Actions'

export default {
    data: () => ({
        loaded: false,
        showGoals: true,
        showEditGoals: false,
        showResources: false,
        showResYesEdit: false,
        showResNoEdit: false,
        showActions: false,
        goalToTrack: null,
        resourceToTrack: null,
        goals: {
            t15: {},
            t10: {},
            t5: {},
            t3: {},
            t1: {}
        }
    }),
    components: {
        Goals,
        EditGoals,
        Resources,
        EditResourcesYes,
        EditResourcesNo,
        Actions
    },
    mounted() {
        this.init();
    },
    methods: {
        reinitFromGoals() {
            this.loaded = false;
            this.setInitialGoals();
            this.showPlease('showGoals');
        },
        reinitFromResources() {
            this.loaded = false;
            this.setInitialGoals();
            this.showPlease('showResources');
        },
        init() {
            if (this.user.goals) {
                if (this.user.goals.t15)    this.goals.t15 = JSON.parse(JSON.stringify(this.user.goals.t15));
                if (this.user.goals.t10)    this.goals.t10 = JSON.parse(JSON.stringify(this.user.goals.t10));
                if (this.user.goals.t5)    this.goals.t5 = JSON.parse(JSON.stringify(this.user.goals.t5));
                if (this.user.goals.t3)    this.goals.t3 = JSON.parse(JSON.stringify(this.user.goals.t3));
                if (this.user.goals.t1)    this.goals.t1 = JSON.parse(JSON.stringify(this.user.goals.t1));
            }
            
            this.loaded = true;
        },
        showPlease(str) {
            this.showGoals = false;
            this.showEditGoals = false;
            this.showResources = false;
            this.showActions = false;
            this.showResYesEdit = false;
            this.showResNoEdit = false;

            this[str] = true;
        },
        setInitialGoals() {
            Personal.updateGoals(this.user.uid, this.goals)
                    .then(response => {
                        if (response === true) {
                            this.$store.dispatch('setGoals', this.goals);
                            Sign.reInitUser(this.user.uid);
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                    });
        },
        watchResources(e) {
            this.goalToTrack = e;
            this.showPlease('showResources')
        },
        watchActions(e) {
            this.resourceToTrack = e;
            this.showPlease('showActions')
        }
    }
}
</script>